import React from 'react';

import { Empty, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import styled from 'styled-components';

import { FailedTaskType } from 'types/tasks';
import { formatTaskDateTime } from 'utils/tasks';

import {
  SecondaryText,
  StatusBadge,
  TabContent,
  TaskName,
  TaskQueueTabHeader,
  WorkerDetails,
} from './TaskQueueTabContent';

const ErrorText = styled.span`
  display: block;
  max-width: 520px;
  color: var(--error-red-title);
  word-break: break-word;
`;

const columns: ColumnsType<FailedTaskType> = [
  {
    title: 'Task',
    dataIndex: 'name',
    key: 'name',
    width: '30%',
    render: (name, task) => (
      <WorkerDetails>
        <TaskName>{name}</TaskName>
        <SecondaryText>{task.task_id}</SecondaryText>
      </WorkerDetails>
    ),
  },
  {
    title: 'State',
    dataIndex: 'state',
    key: 'state',
    width: '10%',
    render: (state) => <StatusBadge error>{state}</StatusBadge>,
  },
  {
    title: 'Failed',
    dataIndex: 'failed_at',
    key: 'failed_at',
    width: '20%',
    render: formatTaskDateTime,
  },
  {
    title: 'Error',
    dataIndex: 'error',
    key: 'error',
    width: '40%',
    render: (error) => <ErrorText>{error || 'No error details reported'}</ErrorText>,
  },
];

type Props = {
  tasks: FailedTaskType[];
  isLoading: boolean;
};

const RecentFailuresTab = ({ tasks, isLoading }: Props) => (
  <TabContent>
    <TaskQueueTabHeader
      title="Recent failures"
      description="The latest 25 tasks that Huey Monitor recorded with an error state."
    />
    <Table
      rowKey="task_id"
      columns={columns}
      dataSource={tasks}
      loading={isLoading}
      pagination={{ pageSize: 10, hideOnSinglePage: true }}
      locale={{ emptyText: <Empty description="No recent task failures were recorded" /> }}
    />
  </TabContent>
);

export default RecentFailuresTab;
